// Static content data for TERRE ET MER CONCIERGERIE

export const STATS = [
  { value: "100%", label: "Clés remises avec le sourire" },
  { value: "78 942", label: "Voyageurs accueillis" },
  { value: "98,7%", label: "Taux de satisfaction voyageurs" },
  { value: "4,9/5", label: "Avis clients" },
  { value: "24/7", label: "Réponse voyageurs (jour et nuit)" },
  { value: "100%", label: "Locations sécurisées" },
  { value: "+30%", label: "Revenus optimisés" },
];

export const SERVICES = [
  {
    icon: "Megaphone",
    title: "Multidiffusion",
    text: "Nous diffusons votre logement sur les plateformes adaptées : Airbnb, Booking.com, Abritel et autres canaux pertinents. Les prix sont ajustés selon la saison, la demande et le marché local.",
  },
  {
    icon: "Key",
    title: "Remise des clés",
    text: "Vous nous confiez les clés de votre logement. Nous organisons les arrivées, les départs et les accès voyageurs en toute sécurité.",
  },
  {
    icon: "Sparkles",
    title: "Ménage & blanchisserie",
    text: "Nous coordonnons les prestations de ménage après chaque départ. Draps, serviettes et linge peuvent être proposés en option selon la formule choisie.",
  },
  {
    icon: "Wrench",
    title: "Maintenance & assistance",
    text: "En cas de problème pendant un séjour, nos partenaires locaux peuvent intervenir 7j/7, y compris la nuit grâce à notre permanence d'astreinte. Notre priorité : protéger et entretenir votre logement.",
  },
  {
    icon: "Camera",
    title: "Shooting photo",
    text: "De belles photos font toute la différence. Nous organisons ou réalisons un shooting photo de qualité pour valoriser votre bien.",
  },
  {
    icon: "CalendarSync",
    title: "Synchronisation",
    text: "Le surbooking, c'est du passé. Nous synchronisons les calendriers grâce à nos outils professionnels.",
  },
  {
    icon: "Gift",
    title: "Pack de bienvenue",
    text: "Mise à disposition d'un kit d'accueil (Shampooing, gel douche, papier toilette, produit vaisselle, éponge, sac-poubelle, petit sac pour la salle de bain) et informations pratiques.",
  },
  {
    icon: "TrendingUp",
    title: "Tarification dynamique avec PriceLabs",
    text: "Grâce à notre partenariat avec PriceLabs (leader mondial du yield management Airbnb), nous ajustons vos tarifs chaque jour : à la hausse en pic de demande (événements locaux, ponts, vacances scolaires, marées d'équinoxe) et à la baisse en creux pour préserver votre taux d'occupation. Concrètement : +30 à +45 % de revenus vs un prix fixe à l'année.",
  },
];

export const PRICING_INCLUDED = [
  "Services 24h/24 · 7j/7 : annonce et communication voyageurs (permanence de nuit)",
  "Photos professionnelles de votre logement",
  "Ajustement quotidien des prix",
  "Vérification des voyageurs : avis et identité lorsque la plateforme le permet",
  "Organisation de l'arrivée et du départ",
  "Accueil 24h/24, 7 jours sur 7",
  "Kit d'accueil (Shampooing, gel douche, papier toilette, produit vaisselle, éponge, sac-poubelle, petit sac pour la salle de bain)",
  "Dommages couverts pour les réservations Airbnb selon les conditions de la plateforme",
  "Conception et rédaction d'un livret d'accueil",
  "Interlocuteurs locaux dans chaque ville",
  "Assistance voyageurs",
  "Suivi propriétaire",
];

// Résultats clients, cas concrets avec chiffres avant/après
// Photos placeholder Unsplash, à remplacer par vraies photos client.
export const RESULTS_CASES = [
  {
    id: "maison-dinard",
    title: "Maison à Dinard",
    city: "Dinard",
    type: "Maison · 2 chambres · 4 voyageurs",
    image: "/images/maison-dinard.jpg",
    before: {
      nightly: 95,
      occupancy: 115,
      revenueYear: 10925,
    },
    after: {
      nightly: 148,
      occupancy: 198,
      revenueYear: 29304,
    },
    delta: 168,
    duration: "12 mois",
    services: [
      "Photos professionnelles",
      "Multidiffusion Airbnb · Booking · Vrbo",
      "Pricing dynamique saisonnier",
      "Accueil voyageurs 24h/24, 7j/7 (permanence de nuit)",
    ],
    quote:
      "Je pensais déjà bien faire. Avec Terre et Mer, mes revenus ont presque triplé la première année, et je n'ai plus rien à gérer.",
    author: "Philippe, propriétaire à Dinard",
  },
  {
    id: "appartement-intra-muros-saint-malo",
    title: "Appartement Intra-Muros (vue mer)",
    city: "Saint-Malo",
    type: "Appartement · 3 chambres · 6 voyageurs",
    image: "/images/appart-intra-muros.jpg",
    before: {
      nightly: 135,
      occupancy: 142,
      revenueYear: 19170,
    },
    after: {
      nightly: 185,
      occupancy: 212,
      revenueYear: 39220,
    },
    delta: 105,
    duration: "10 mois",
    services: [
      "Refonte complète de l'annonce",
      "Shooting photo + drone",
      "Kit d'accueil breton premium",
      "Livret d'accueil digital",
    ],
    quote:
      "L'annonce a été transformée. Je réserve désormais des mois à l'avance, y compris hors saison. Un vrai soulagement.",
    author: "Catherine, propriétaire à Saint-Malo",
  },
  {
    id: "villa-familiale-cancale",
    title: "Villa familiale avec jardin",
    city: "Cancale",
    type: "Villa · 4 chambres · 8 voyageurs",
    image:
      "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    before: {
      nightly: 180,
      occupancy: 95,
      revenueYear: 17100,
    },
    after: {
      nightly: 265,
      occupancy: 178,
      revenueYear: 47170,
    },
    delta: 176,
    duration: "8 mois",
    services: [
      "Stratégie longue durée familles",
      "Mise en valeur de l'espace extérieur",
      "Pricing saisons + événements locaux",
      "Suivi linge hôtelier",
    ],
    quote:
      "Avant, la maison restait vide 9 mois sur 12. Maintenant elle tourne presque toute l'année, sans jamais m'appeler pour un problème.",
    author: "Jean-Luc, propriétaire à Cancale",
  },
  {
    id: "studio-saint-cast",
    title: "Studio bord de plage",
    city: "Saint-Cast-le-Guildo",
    type: "Studio · 1 chambre · 2 voyageurs",
    image: "/images/studio-saint-cast.jpg",
    before: {
      nightly: 58,
      occupancy: 88,
      revenueYear: 5104,
    },
    after: {
      nightly: 89,
      occupancy: 186,
      revenueYear: 16554,
    },
    delta: 224,
    duration: "14 mois",
    services: [
      "Repositionnement de l'annonce",
      "Photos professionnelles",
      "Pricing dynamique week-end",
      "Ménage hôtelier + linge inclus",
    ],
    quote:
      "Ce studio ne rapportait presque rien. Aujourd'hui il finance largement les travaux de notre résidence principale.",
    author: "Sylvie, propriétaire à Saint-Cast",
  },
  {
    id: "longere-dinan",
    title: "Longère rénovée en centre historique",
    city: "Dinan",
    type: "Maison · 3 chambres · 6 voyageurs",
    image: "/images/longere-dinan.jpg",
    before: {
      nightly: 120,
      occupancy: 105,
      revenueYear: 12600,
    },
    after: {
      nightly: 172,
      occupancy: 194,
      revenueYear: 33368,
    },
    delta: 165,
    duration: "11 mois",
    services: [
      "Storytelling patrimoine breton",
      "Shooting photo éditorial",
      "Multidiffusion premium",
      "Conciergerie complète 24h/24, 7j/7",
    ],
    quote:
      "L'équipe a su valoriser le charme breton du lieu. Le logement est presque plein d'avril à octobre.",
    author: "Marc & Isabelle, propriétaires à Dinan",
  },
];

export const RESULTS_STATS = [
  { value: "+168%", label: "Revenu moyen supplémentaire" },
  { value: "186", label: "Nuits réservées / an (moyenne)" },
  { value: "4,9/5", label: "Note moyenne voyageurs" },
  { value: "98%", label: "Propriétaires qui restent chez nous" },
];

export const CASE_STUDIES = [
  {
    name: "Claire",
    description:
      "Claire profite de sa maison de vacances en Bretagne et la loue en courte durée lorsqu'elle n'y séjourne pas.",
    type: "Maison de vacances – Bretagne",
    capacity: "4 personnes",
    revenue: "1 957,30 €",
    image: "/images/claire.jpg",
  },
  {
    name: "Ryzlène",
    description:
      "Ryzlène a réalisé un investissement locatif et souhaite louer en courte durée toute l'année.",
    type: "Appartement T2 – Côte d'Émeraude",
    capacity: "2 personnes",
    revenue: "1 340,50 €",
    image: "/images/ryzlene.jpg",
  },
  {
    name: "Jérôme & Julia",
    description:
      "Ils louent leur appartement pendant leurs congés et nous confient toute l'organisation.",
    type: "Appartement T3 – Saint-Malo / Dinard",
    capacity: "6 personnes",
    revenue: "1 854,80 €",
    image: "/images/jerome-julia.jpg",
  },
];

export const REASONS = [
  {
    icon: "Clock",
    title: "Gagnez 50 heures par mois",
    text: "Nous nous occupons des annonces, messages voyageurs, arrivées, départs, ménage et imprévus.",
  },
  {
    icon: "Home",
    title: "Logement entretenu",
    text: "Votre logement est vérifié régulièrement par notre équipe locale afin de préserver sa qualité.",
  },
  {
    icon: "TrendingUp",
    title: "Jusqu'à 30% de revenus en plus",
    text: "Grâce à la courte et moyenne durée, aux prix dynamiques et à une annonce optimisée, vos revenus peuvent fortement progresser.",
  },
];

export const TESTIMONIALS = [
  {
    name: "Christelle",
    city: "Saint-Malo",
    quote:
      "Pendant mes vacances, je loue mon logement avec TERRE ET MER CONCIERGERIE. L'équipe est efficace, disponible et rassurante.",
    image:
      "https://images.unsplash.com/photo-1758686254563-5c5ab338c8b9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxzZW5pb3IlMjBzbWlsaW5nJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzc3ODQzNTI1fDA&ixlib=rb-4.1.0&q=85&w=400",
  },
  {
    name: "Jean-Louis",
    city: "Dinard",
    quote:
      "Service convivial, sérieux et très professionnel. Je recommande à tous les propriétaires qui veulent louer sur Airbnb sans stress.",
    image:
      "https://images.unsplash.com/photo-1758691030490-fe1cb6c972ce?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwyfHxzZW5pb3IlMjBtYW4lMjBzbWlsaW5nJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzc3ODQzNTQzfDA&ixlib=rb-4.1.0&q=85&w=400",
  },
  {
    name: "Jeannine",
    city: "Saint-Malo",
    quote:
      "Une équipe locale de grande qualité. Pour mon logement à Saint-Malo, je me sens accompagné et les voyageurs sont satisfaits.",
    image:
      "https://images.unsplash.com/photo-1763573676689-bf2d7b474208?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwyfHxzZW5pb3IlMjBzbWlsaW5nJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzc3ODQzNTI1fDA&ixlib=rb-4.1.0&q=85&w=400",
  },
  // === MOCK-UP, Témoignages Morbihan (à remplacer par de vrais avis clients) ===
  {
    name: "Patrick",
    city: "Damgan",
    quote:
      "Ma maison à Pénerf restait vide la moitié de l'année. Depuis que la conciergerie s'en occupe, elle tourne presque toute la saison, et je n'ai plus à gérer un seul message voyageur.",
    image:
      "https://images.unsplash.com/photo-1545167622-3a6ac756afa4?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
    isMockup: true,
  },
  {
    name: "Anne-Sophie",
    city: "La Roche-Bernard",
    quote:
      "J'avais peur de confier mon appartement avec vue sur le port à des inconnus. L'équipe locale est attentive, professionnelle et les voyageurs adorent le livret d'accueil. Vraiment haut de gamme.",
    image:
      "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
    isMockup: true,
  },
  {
    name: "Christelle",
    city: "Marzan",
    quote:
      "À 45 ans, je n'avais ni le temps ni l'énergie de tout gérer toute seule. Notre maison familiale à Marzan dormait depuis trop longtemps. L'équipe a tout pris en main : photos, annonces, voyageurs, ménage… et les revenus ont dépassé ce que j'imaginais dès la première saison.",
    image:
      "https://images.unsplash.com/photo-1580489944761-15a19d654956?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
    isMockup: true,
  },
];

export const CITIES = [
  "Saint-Malo",
  "Cancale",
  "Dinard",
  "Dinan",
  "Saint-Cast-le-Guildo",
  "Saint-Briac-sur-Mer",
  "Lancieux",
  "Beaussais-sur-Mer",
  "Pleurtuit",
  "Saint-Lunaire",
  "Saint-Coulomb",
  "Saint-Méloir-des-Ondes",
  "Dol-de-Bretagne",
  "Mont-Dol",
  "Pléboulle",
  "Saint-Jouan-des-Guérets",
  "La Richardais",
  "Le Minihic-sur-Rance",
  "Ploubalay",
  "Saint-Cast-le-Guildo",
  "Lancieux",
  "Saint-Jacut-de-la-Mer",
  "Matignon",
  "Créhen",
  "Plancoët",
  "Fréhel",
  "Erquy",
  "Pléneuf-Val-André",
  "Lamballe",
  "Saint-Brieuc",
  // Morbihan (56), Équipe Sud Bretagne
  "Damgan",
  "La Roche-Bernard",
  "Ambon",
  "Marzan",
  "Péaule",
  "Muzillac",
];

export const SEO_CITIES_TEXT = [
  "Conciergerie Airbnb Saint-Malo",
  "Conciergerie Airbnb Cancale",
  "Conciergerie Airbnb Dinard",
  "Conciergerie Airbnb Dinan",
  "Conciergerie Airbnb Saint-Cast-le-Guildo",
  "Conciergerie Airbnb Saint-Briac-sur-Mer",
  "Conciergerie Airbnb Lancieux",
  "Conciergerie Airbnb Pleurtuit",
  "Conciergerie Airbnb Saint-Lunaire",
  "Conciergerie Airbnb Côte d'Émeraude",
  "Conciergerie Airbnb Damgan",
  "Conciergerie Airbnb La Roche-Bernard",
  "Conciergerie Airbnb Ambon",
  "Conciergerie Airbnb Muzillac",
  "Conciergerie Airbnb Morbihan",
  "Conciergerie location courte durée Bretagne",
];

export const ENGAGEMENTS = [
  {
    icon: "Eye",
    title: "Transparence des tarifs",
    text: "Une commission claire de 15% TTC, sans frais cachés ni surprise. Vous savez précisément ce que vous payez.",
  },
  {
    icon: "Zap",
    title: "Réactivité 24h/24 · 7j/7",
    text: "Notre équipe locale répond aux voyageurs et propriétaires tous les jours, 24h/24, week-ends et jours fériés inclus. Nous assurons une permanence de nuit pour traiter les messages plateformes et toute urgence.",
  },
  {
    icon: "Heart",
    title: "Respect du logement",
    text: "Vérifications régulières, vérification des voyageurs et entretien soigné pour préserver la qualité de votre bien.",
  },
  {
    icon: "TrendingUp",
    title: "Optimisation des revenus",
    text: "Ajustement quotidien des prix, multidiffusion et référencement optimisé pour maximiser votre rentabilité.",
  },
  {
    icon: "MapPin",
    title: "Deux équipes locales",
    text: "Une équipe à Saint-Malo & sur la Côte d'Émeraude (35 / 22) et une équipe distincte dans le Morbihan (56), interlocuteurs présents sur chaque ville d'intervention.",
  },
  {
    icon: "MessageCircle",
    title: "Communication claire",
    text: "Suivi propriétaire régulier, rapports détaillés et un seul interlocuteur dédié à votre bien.",
  },
];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1646489346674-b8640e514453?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxzYWludCUyMG1hbG8lMjBicmV0YWduZXxlbnwwfHx8fDE3Nzc4NDM1NDJ8MA&ixlib=rb-4.1.0&q=85&w=1800";

export const HERO_IMAGE_ALT =
  "https://images.pexels.com/photos/33622539/pexels-photo-33622539.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400";

export const PROCESS_STEPS = [
  {
    number: "01",
    title: "Configurer votre logement",
    text: "En quelques clics, transmettez-nous les informations propres à votre logement via le formulaire.",
    icon: "FileText",
  },
  {
    number: "02",
    title: "Entretien téléphonique",
    text: "Nous vous contactons pour répondre à vos questions et fixer un rendez-vous dans votre bien.",
    icon: "Phone",
  },
  {
    number: "03",
    title: "Visite et formalités",
    text: "Nous visitons votre bien et notons toutes les conditions que vous souhaitez concernant la location afin de les appliquer.",
    icon: "Home",
  },
  {
    number: "04",
    title: "Top départ",
    text: "Après réalisation de la séance photos, nous rédigeons et diffusons votre annonce. Notre service est prêt à recevoir vos premiers voyageurs.",
    icon: "Rocket",
  },
];

export const OPERATIONS_NUMBERS = [
  { value: "18 299", label: "Lits bordés", icon: "BedDouble" },
  { value: "40 598", label: "Serviettes pliées", icon: "Shirt" },
  { value: "29 981", label: "Capsules de café distribuées", icon: "Coffee" },
];

export const SERVICES_DETAILED = [
  {
    icon: "FileText",
    title: "Création de l'annonce",
    text: "Vous bénéficiez d'une annonce professionnelle de qualité, conviviale et détaillée de votre bien avec un titre donnant envie de réserver. Multi-diffusion sur les plus grandes plateformes.",
    image: "https://images.unsplash.com/photo-1554995207-c18c203602cb?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80",
    alt: "Création d'annonce locative professionnelle",
  },
  {
    icon: "Camera",
    title: "Photographies professionnelles",
    text: "Pour que votre annonce accroche le regard des voyageurs, il lui faut plusieurs visuels de qualité. Nous travaillons avec de véritables professionnels de la photographie qui sauront mettre en valeur votre logement en prenant soin de le montrer sous son meilleur angle, afin d'optimiser votre annonce.",
    image: "/images/photo-pro.jpg",
    alt: "Photographe Terre et Mer Conciergerie en train de shooter un salon lumineux",
  },
  {
    icon: "TrendingUp",
    title: "Optimisation des prix",
    text: "Grâce à notre partenariat avec PriceLabs, la plateforme de yield management Airbnb la plus utilisée au monde (+400 000 logements pilotés), nous ajustons vos tarifs chaque jour : à la hausse en pic de demande (Festival du film britannique de Dinard, Route du Rhum, marées d'équinoxe, ponts de mai, vacances scolaires) et à la baisse en creux pour préserver votre taux d'occupation. Notre équipe locale double cet algorithme d'une supervision humaine pour caler les événements ultra-bretons que la machine ne voit pas seule. Licence PriceLabs incluse dans la formule 15 % TTC, à notre charge.",
    image: "/images/pricing-airbnb.jpg",
    alt: "Tableau de tarifs Airbnb par nuit affiché sur MacBook, optimisation des prix avec PriceLabs",
  },
  {
    icon: "UserCheck",
    title: "Sélection des voyageurs",
    text: "Afin de garantir la sécurité de votre bien, nous choisissons uniquement les voyageurs les plus fiables pour séjourner chez vous. Vérification des avis et de l'identité lorsque les plateformes le permettent. Nous mettons un point d'honneur à ce que votre logement reste en sécurité.",
    image: "/images/selection-voyageurs.jpg",
    alt: "Enfant en marinière observant aux jumelles assis sur une valise, sélection rigoureuse des voyageurs",
  },
  {
    icon: "MessageCircle",
    title: "Communication 7j/7 · 24h/24",
    text: "Du tout premier contact aux questions de fin de séjour, nous gérons l'ensemble des échanges avec les voyageurs. Nous organisons l'accueil de vos invités (7j/7 et 24h/24) à leur arrivée dans votre logement et restons à leur disposition durant la totalité de leur séjour.",
    image: "https://images.unsplash.com/photo-1551836022-d5d88e9218df?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80",
    alt: "Communication voyageurs 7j/7",
  },
  {
    icon: "Sparkles",
    title: "Ménage & linge",
    text: "Ménage de qualité entre chaque séjour. Draps, serviettes et torchons fournis pour chaque locataire (option). Réapprovisionnement des kits d'accueil (produits de première nécessité) et lavage du linge inclus dans la formule complète.",
    image: "/images/menage-linge.jpg",
    alt: "Serviettes blanches roulées et linge hôtelier sur lit fait, service ménage et blanchisserie",
    note: "Ménage inclus, option linge (draps & serviettes hôteliers) à +3% de commission supplémentaire.",
  },
  {
    icon: "ShieldCheck",
    title: "Locations sécurisées",
    text: "Votre location est commercialisée exclusivement sur des plateformes de réservation sécurisées (Airbnb, Booking, Vrbo, Tripadvisor). Votre bien est loué sous caution avec couverture des dommages selon les conditions de chaque plateforme.",
    image: "/images/location-securisee.jpg",
    alt: "Cuisine ouverte moderne d'un logement loué, locations sécurisées via plateformes",
  },
  {
    icon: "Wrench",
    title: "Maintenance",
    text: "Du changement d'une ampoule aux petites réparations, en passant par la préparation de votre logement ou le montage de meubles, nous nous occupons des tâches de maintenance de votre logement à partir de 15€/h TTC (ou 30€/h si prestataire externe).",
    image: "/images/maintenance-van.jpg",
    alt: "Technicien Terre et Mer Conciergerie devant le véhicule de service floqué aux couleurs de la marque",
  },
];

export const CONTACT = {
  email: "contact@terreetmer-conciergerie.fr",
  phone: "02 55 99 66 25",
  phoneHref: "tel:+33255996625",
  calendly: "https://calendly.com/terretmer/rendez-vous-15min",
  hours: [
    { day: "Lun., Ven.", slots: "10h–12h · 14h–17h" },
    { day: "Samedi", slots: "10h–12h" },
    { day: "Dimanche", slots: "Fermé" },
  ],
};

// City landing pages (per ville d'intervention)
// Curated distinct images per city, Brittany / Côte d'Émeraude themed
const IMG = {
  saintMalo: "/images/saint-malo-remparts.jpg",
  // Coast/beach scenes
  bretagneCoast: "https://images.pexels.com/photos/33622539/pexels-photo-33622539.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1800",
  // Interiors (kept for introImage)
  cozyInterior: "https://images.unsplash.com/photo-1554995207-c18c203602cb?ixlib=rb-4.0.3&auto=format&fit=crop&w=1800&q=80",
  luxInterior: "https://images.unsplash.com/photo-1774423864869-702b21c2490a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBjb2FzdGFsJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzc3ODQzNTI1fDA&ixlib=rb-4.1.0&q=85&w=1800",
  modernInterior: "https://images.unsplash.com/photo-1769737122085-97b1ee5ab104?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBjb2FzdGFsJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzc3ODQzNTI1fDA&ixlib=rb-4.1.0&q=85&w=1800",
};

// Distinct city hero images, each ville gets its own to avoid repetition
const CITY_IMG = {
  saintMalo: "/images/saint-malo-remparts.jpg",
  cancale: "/images/cancale.jpg", // port et maisons traditionnelles de Cancale
  dinard: "/images/dinard.jpg", // plage et tentes rayées emblématiques de Dinard
  dinan: "/images/dinan.jpg", // ruelle pavée et maisons à colombages de Dinan
  saintLunaire: "/images/saint-lunaire.jpg", // grande plage et villas belle époque
  saintCoulomb: "/images/saint-coulomb.jpg", // plage et bateaux à marée basse
  saintMeloir: "/images/saint-meloir.jpg", // Mairie de Saint-Méloir-des-Ondes
  dolDeBretagne: "/images/dol-de-bretagne.jpg", // maisons à colombages de Dol-de-Bretagne
  montDol: "/images/mont-dol.jpg", // Mairie de Mont-Dol au pied du Mont-Dol
  pleboulle: "/images/pleboulle.jpg", // église Saint-Pierre de Pléboulle au clocher en granit
  saintJouan: "/images/saint-jouan.jpg", // Mairie de Saint-Jouan-des-Guérets
  laRichardais: "/images/la-richardais.jpg", // port et bateaux sur la Rance
  leMinihic: "/images/le-minihic.jpg", // maisons en pierre du Minihic-sur-Rance
  saintCast: "/images/saint-cast.jpg", // plage et villas de Saint-Cast
  lancieux: "/images/lancieux.jpg", // moulin emblématique de Lancieux
  saintJacut: "/images/saint-jacut.jpg", // peninsula coast
  ploubalay: "/images/ploubalay.jpg", // coastal village
  matignon: "/images/matignon.jpg", // Mairie de Matignon
  crehen: "/images/crehen.jpg", // église de Créhen
  plancoet: "/images/plancoet.jpg", // rivière Arguenon
  pleurtuit: "/images/pleurtuit.jpg", // moulin et rivière de Pleurtuit
  saintBriac: "/images/saint-briac.jpg", // mouillage et château de Nessay à Saint-Briac
  chateauneuf: "/images/chateauneuf-ille.jpg", // Mairie en pierre de Châteauneuf-d'Ille-et-Vilaine
  saintBenoit: "/images/saint-benoit-des-ondes.jpg", // rue principale et maisons en pierre
  pleudihen: "/images/pleudihen.jpg", // village de Pleudihen-sur-Rance vu depuis la Rance
  saintLormel: "/images/saint-lormel.jpg", // Mairie moderne de Saint-Lormel
  languenan: "/images/languenan.jpg", // église en pierre de Languenan
  corseul: "/images/corseul.jpg", // église et place de Corseul, ancienne capitale gallo-romaine
  pluduno: "/images/pluduno.jpg", // manoir historique en pierre de Pluduno
  // === Morbihan (56), Équipe Sud Bretagne ===
  damgan: "/images/damgan.jpg", // chapelle Saint-Pierre et ancre marine de Damgan
  laRocheBernard: "/images/la-roche-bernard.jpg", // port de plaisance et vieille ville de La Roche-Bernard
  ambon: "/images/ambon.jpg", // longère médiévale en pierre d'Ambon
  marzan: "/images/marzan.jpg", // mairie de Marzan
  peaule: "/images/peaule.jpg", // crêperie en pierre du Vieux Bourg de Péaule
  muzillac: "/images/muzillac.jpg", // Office de tourisme du Pays de Muzillac (façade en pierre fleurie)
};

const baseBenefits = [
  {
    icon: "Clock",
    title: "Gagnez 50 heures / mois",
    text: "Notre conciergerie est spécialisée dans le bien-être de nos clients, et s'occupe de tout. Vous êtes tranquille.",
  },
  {
    icon: "Home",
    title: "Logement entretenu",
    text: "Votre logement est entretenu et vérifié régulièrement par notre équipe locale. Il restera toujours impeccable.",
  },
  {
    icon: "TrendingUp",
    title: "+30% de revenus",
    text: "La location courte et moyenne durée est plus rentable. Vos revenus augmentent de +30% en moyenne.",
  },
];

const baseDifferentiators = [
  {
    icon: "Banknote",
    title: "Versement des revenus en direct",
    text: "Le versement des locations est effectué le lendemain de l'arrivée de vos voyageurs pour la majorité des plateformes, directement sur votre RIB.",
  },
  {
    icon: "RefreshCw",
    title: "Contrat renouvelé tous les 90 jours",
    text: "Fini les engagements pendant 6 ou 12 mois ! Vous gardez la main sur votre logement.",
  },
  {
    icon: "CalendarX",
    title: "Calendrier bloquable à volonté",
    text: "Vous disposez d'un lien d'accès vous permettant de bloquer le calendrier quand vous le souhaitez.",
  },
];

const baseStats = [
  { value: "60 588", label: "Serviettes pliées", icon: "Shirt" },
  { value: "40 392", label: "Lits bordés", icon: "BedDouble" },
  { value: "80 784", label: "Gels douches distribués", icon: "Droplets" },
  { value: "87 s", label: "Délai de réponse", icon: "Timer" },
];

export const CITIES_DATA = {
  cancale: {
    slug: "cancale",
    name: "Cancale",
    department: "35",
    region: "Ille-et-Vilaine, Côte d'Émeraude",
    heroImage: CITY_IMG.cancale,
    geo: { lat: 48.6772, lng: -1.8531 },
    postalCode: "35260",
    intro: {
      avgPrice: "70 €",
      travelers: "85 000+",
      tgv: "2h15 de Paris-Montparnasse",
      text: "À seulement 2h15 de Gare Montparnasse en TGV, Cancale est une destination incontournable, réputée pour ses huîtres d'exception. Vous pouvez les savourer directement sur le marché, face à la mer, pour une expérience authentique. Côté location saisonnière, la ville a déjà séduit plus de 85 000 voyageurs sur Airbnb. Quelle que soit la saison, Cancale offre un cadre idéal pour une escapade. Le tarif moyen à la nuitée s'établit autour de 70 €.",
      serviceText: "Nous avons sélectionné pour vous les meilleurs City Managers de Cancale afin d'assurer un accueil et des départs voyageurs irréprochables. Pour garantir une expérience de qualité, nos prestations incluent un ménage complet avec fourniture du linge de maison (draps, serviettes…) à la hauteur de vos exigences. Confiez-nous vos clés, nous mettons tout en œuvre pour optimiser la rentabilité de votre bien comme s'il s'agissait du nôtre. Notre équipe définit une stratégie tarifaire sur mesure, ajustée en fonction des événements locaux (Route du Rhum, saison estivale…) afin de maximiser vos revenus. Avec Terre et Mer Conciergerie, votre annonce est diffusée sur les principales plateformes de réservation telles que Airbnb, Booking.com et Vrbo.",
    },
    benefits: baseBenefits, differentiators: baseDifferentiators, stats: baseStats,
  },
  "saint-malo": {
    slug: "saint-malo", name: "Saint-Malo", department: "35", region: "Ille-et-Vilaine, Côte d'Émeraude",
    heroImage: CITY_IMG.saintMalo, introImage: IMG.bretagneCoast,
    intro: {
      avgPrice: "95 €", travelers: "210 000+", tgv: "2h15 de Paris-Montparnasse",
      text: "Cité corsaire intra-muros, Saint-Malo est l'une des destinations les plus prisées de Bretagne. Ses remparts emblématiques, ses plages de sable fin (Bon-Secours, Plage du Sillon) et son port animé attirent plus de 210 000 voyageurs chaque année sur Airbnb. Avec un tarif moyen de 95 € la nuit et une demande qui s'étire toute l'année, Route du Rhum, festival Étonnants Voyageurs, marées d'équinoxe, Saint-Malo offre un potentiel locatif exceptionnel.",
      serviceText: "Nos City Managers connaissent chaque ruelle d'intra-muros, de Paramé et de Saint-Servan. Nous adaptons notre stratégie tarifaire aux temps forts de la cité corsaire (grandes marées, festivals, vacances scolaires) pour faire grimper votre taux d'occupation. Linge fourni, ménage de qualité hôtelière, kit d'accueil avec spécialités locales : votre logement reflète l'âme malouine. Diffusion sur Airbnb, Booking.com, Vrbo et Tripadvisor pour une visibilité maximale.",
    },
    benefits: baseBenefits, differentiators: baseDifferentiators, stats: baseStats,
  },
  dinard: {
    slug: "dinard", name: "Dinard", department: "35", region: "Ille-et-Vilaine, Côte d'Émeraude",
    heroImage: CITY_IMG.dinard, introImage: IMG.luxInterior,
    intro: {
      avgPrice: "120 €", travelers: "65 000+", tgv: "2h45 de Paris (via Saint-Malo)",
      text: "Joyau de la Belle Époque, Dinard a su préserver son élégance balnéaire avec ses villas Art Nouveau, sa promenade du Clair de Lune et ses plages mythiques (l'Écluse, Saint-Énogat, Prieuré). Le Festival du film britannique chaque automne, le yachting et les amateurs d'architecture en font une destination très demandée. Avec un tarif moyen de 120 € la nuit, Dinard se positionne sur un segment haut de gamme, idéal pour valoriser un bien de caractère.",
      serviceText: "Dinard demande une approche premium : photographies soignées qui captent la lumière atlantique, annonces rédigées en français et en anglais pour la clientèle internationale, livret d'accueil mettant en avant le festival, le casino et les sentiers côtiers GR34. Notre équipe locale assure check-in physique sur demande pour une expérience digne d'un palace. Diffusion multi-plateformes et tarification dynamique selon les événements (festival, régates, congrès).",
    },
    benefits: baseBenefits, differentiators: baseDifferentiators, stats: baseStats,
  },
  dinan: {
    slug: "dinan", name: "Dinan", department: "22", region: "Côtes-d'Armor, Vallée de la Rance",
    heroImage: CITY_IMG.dinan, introImage: IMG.bretagneCoast,
    intro: {
      avgPrice: "75 €", travelers: "45 000+", tgv: "2h30 de Paris-Montparnasse",
      text: "Cité médiévale parmi les mieux conservées de Bretagne, Dinan séduit par ses remparts, ses maisons à pans de bois et son port sur la Rance. Classée parmi les Plus Beaux Détours de France, la ville attire les amoureux d'histoire et les croisiéristes (port de plaisance). Le tarif moyen de 75 € la nuit et une fréquentation forte d'avril à octobre, fête des Remparts en juillet, en font un choix sûr pour la location courte durée.",
      serviceText: "Notre City Manager basé sur la Côte d'Émeraude couvre Dinan et les environs. Nous valorisons votre logement avec des photos qui captent le charme médiéval, un livret d'accueil orienté patrimoine (basilique Saint-Sauveur, tour de l'Horloge, Léhon) et une stratégie tarifaire calée sur la fête des Remparts et les week-ends prolongés. Annonce diffusée sur Airbnb, Booking.com, Vrbo et Tripadvisor.",
    },
    benefits: baseBenefits, differentiators: baseDifferentiators, stats: baseStats,
  },
  "saint-lunaire": {
    slug: "saint-lunaire", name: "Saint-Lunaire", department: "35", region: "Ille-et-Vilaine, Côte d'Émeraude",
    heroImage: CITY_IMG.saintLunaire, introImage: IMG.luxInterior,
    intro: {
      avgPrice: "95 €", travelers: "25 000+", tgv: "2h45 de Paris",
      text: "Station balnéaire familiale et chic, Saint-Lunaire combine villas Belle Époque, plages tranquilles (Grande Plage, Longchamp) et un golf 18 trous mythique. Voisine de Dinard et Saint-Briac, la commune attire une clientèle haut de gamme à la recherche de calme. Avec un tarif moyen de 95 € la nuit, votre bien à Saint-Lunaire bénéficie d'une saison étendue d'avril à octobre.",
      serviceText: "Saint-Lunaire est une perle préservée. Nous mettons en avant l'esprit « famille » et « art de vivre » de la station : proximité du golf, sentiers du GR34, ports de pêche. Photos lumineuses, descriptifs en français/anglais, accueil par notre équipe locale, ménage et linge fournis. Tarification ajustée aux marées, événements golf et vacances scolaires.",
    },
    benefits: baseBenefits, differentiators: baseDifferentiators, stats: baseStats,
  },
  "saint-coulomb": {
    slug: "saint-coulomb", name: "Saint-Coulomb", department: "35", region: "Ille-et-Vilaine, entre Saint-Malo et Cancale",
    heroImage: CITY_IMG.saintCoulomb, introImage: IMG.saintMalo,
    intro: {
      avgPrice: "85 €", travelers: "18 000+", tgv: "2h15 de Paris (via Saint-Malo)",
      text: "Entre Saint-Malo et Cancale, Saint-Coulomb offre un littoral spectaculaire : Pointe du Grouin, plages des Chevrets et de la Guimorais, anses sauvages. Idéale pour les amoureux de nature, la commune attire 18 000 voyageurs Airbnb par an, séduits par la randonnée GR34 et le calme contrastant avec l'effervescence de Saint-Malo. Tarif moyen autour de 85 € la nuit.",
      serviceText: "Saint-Coulomb est une destination « nature & littoral ». Nous valorisons votre bien avec des photos en extérieur (plages, falaises, sentiers), un livret d'accueil détaillant les itinéraires de randonnée et les bonnes adresses (huîtres de Cancale, restaurants du Guesclin). Notre équipe locale assure une réactivité immédiate, à seulement 10 minutes de Saint-Malo.",
    },
    benefits: baseBenefits, differentiators: baseDifferentiators, stats: baseStats,
  },
  "saint-meloir-des-ondes": {
    slug: "saint-meloir-des-ondes", name: "Saint-Méloir-des-Ondes", department: "35", region: "Ille-et-Vilaine, Pays Malouin",
    heroImage: CITY_IMG.saintMeloir, introImage: IMG.bretagneCoast,
    intro: {
      avgPrice: "75 €", travelers: "12 000+", tgv: "2h15 de Paris (via Saint-Malo)",
      text: "Saint-Méloir-des-Ondes incarne la campagne malouine authentique : maraîchage, vergers, fermes en pierre. À 10 minutes de Saint-Malo et de Cancale, la commune séduit les voyageurs en quête d'un séjour calme avec accès rapide aux sites côtiers. Le tarif moyen de 75 € la nuit en fait une option accessible et rentable, particulièrement pour les maisons familiales.",
      serviceText: "Nous mettons en valeur le caractère « pierre et campagne » de votre bien : photos qui captent les volumes, mise en avant de la proximité avec Saint-Malo, Cancale, Mont-Saint-Michel. Livret d'accueil orienté terroir (cidre, légumes du marché, huîtres). Notre équipe locale intervient sur place sous 30 minutes pour les check-in physiques ou imprévus.",
    },
    benefits: baseBenefits, differentiators: baseDifferentiators, stats: baseStats,
  },
  "dol-de-bretagne": {
    slug: "dol-de-bretagne", name: "Dol-de-Bretagne", department: "35", region: "Ille-et-Vilaine, Marais de Dol",
    heroImage: CITY_IMG.dolDeBretagne, introImage: IMG.bretagneCoast,
    intro: {
      avgPrice: "65 €", travelers: "22 000+", tgv: "TGV direct (1h55 de Paris)",
      text: "Ancienne capitale de la Bretagne, Dol-de-Bretagne fascine par sa cathédrale Saint-Samson (XIIe siècle), ses ruelles médiévales et le menhir du Champ-Dolent. Porte d'entrée du Mont-Saint-Michel (à 25 minutes), la ville attire 22 000 voyageurs Airbnb par an. Le TGV direct depuis Paris (1h55) en fait une destination week-end très demandée. Tarif moyen : 65 € la nuit.",
      serviceText: "Dol-de-Bretagne séduit par son patrimoine. Nous orientons les photos vers le charme historique (pierres apparentes, poutres, jardins clos) et rédigeons des annonces optimisées Mont-Saint-Michel, un argument SEO majeur. Stratégie tarifaire sur les week-ends et les vacances scolaires. Notre City Manager couvre Dol et le marais voisin.",
    },
    benefits: baseBenefits, differentiators: baseDifferentiators, stats: baseStats,
  },
  "mont-dol": {
    slug: "mont-dol", name: "Mont-Dol", department: "35", region: "Ille-et-Vilaine, Baie du Mont-Saint-Michel",
    heroImage: CITY_IMG.montDol, introImage: IMG.bretagneCoast,
    intro: {
      avgPrice: "72 €", travelers: "14 000+", tgv: "TGV Dol-de-Bretagne (1h55 de Paris) à 5 min",
      text: "Posé au sommet d'un piton granitique culminant à 65 mètres, Mont-Dol est un village d'exception qui domine la baie du Mont-Saint-Michel. Ses panoramas à 360° sur les marais, sa chapelle Notre-Dame-de-l'Espérance, ses mégalithes et son moulin à vent en font une destination Airbnb à fort caractère. À seulement 5 minutes de Dol-de-Bretagne (TGV direct Paris 1h55) et 25 minutes du Mont-Saint-Michel, la commune capte une clientèle de week-end haut de gamme et internationale. Tarif moyen : 72 € la nuit, avec une saison étendue d'avril à novembre grâce au tourisme patrimonial.",
      serviceText: "Mont-Dol est un joyau confidentiel, c'est précisément ce qui fait sa valeur Airbnb. Nous valorisons votre bien comme une étape « hors du temps » entre Saint-Malo et le Mont-Saint-Michel : photos qui captent les vues panoramiques sur la baie, livret d'accueil orienté randonnées (sentier de la Croix Madame, ascension du Mont-Dol), gastronomie locale (huîtres de Cancale à 20 min, pré-salé du Mont). Annonces bilingues français/anglais pour accueillir la clientèle britannique nombreuse sur ce secteur. Notre City Manager intervient en moins de 20 minutes depuis Saint-Malo.",
    },
    benefits: baseBenefits, differentiators: baseDifferentiators, stats: baseStats,
  },
  pleboulle: {
    slug: "pleboulle", name: "Pléboulle", department: "22", region: "Côtes-d'Armor, Arrière-pays Côte d'Émeraude",
    heroImage: CITY_IMG.pleboulle, introImage: IMG.bretagneCoast,
    intro: {
      avgPrice: "68 €", travelers: "6 500+", tgv: "Saint-Malo TGV (35 min) · Paris en 2h25",
      text: "À seulement 10 minutes de Saint-Cast-Le Guildo et 15 minutes de Lancieux, Pléboulle est un village authentique de l'arrière-pays Côte d'Émeraude. Son église Saint-Pierre au clocher imposant (XVᵉ siècle), ses fermes de caractère, ses pâturages et ses chemins creux en font un cadre rural préservé recherché par les voyageurs qui veulent du calme à 10 minutes des plages. Tarif moyen 68 € la nuit, 6 500 voyageurs Airbnb par an, taux d'occupation 62 %, un excellent ratio pour un bien rural bien piloté.",
      serviceText: "Pléboulle = positionnement « campagne bretonne à 10 min de la mer ». Nous valorisons les volumes des longères, jardins clos, animaux des fermes voisines (point fort pour les familles avec enfants). Annonces qui exploitent la proximité Saint-Cast (10 min) + Sables-d'Or-les-Pins (15 min) + Cap Fréhel (25 min). Notre City Manager basé à Ploubalay (12 min) intervient sur l'ensemble de la commune.",
    },
    benefits: baseBenefits, differentiators: baseDifferentiators, stats: baseStats,
  },

  ploubalay: {
    slug: "ploubalay", name: "Ploubalay", department: "22", region: "Côtes-d'Armor, Beaussais-sur-Mer",
    heroImage: CITY_IMG.ploubalay, introImage: IMG.cozyInterior,
    intro: {
      avgPrice: "65 €", travelers: "12 000+", tgv: "2h45 de Paris (via Saint-Malo)",
      text: "Cœur de la commune nouvelle de Beaussais-sur-Mer (avec Plessix-Balisson et Trégon), Ploubalay est un point de chute idéal entre Saint-Malo, Dinard et la pointe du Cap Fréhel. À deux pas des plages de Lancieux et Saint-Jacut, la commune offre un cadre tranquille à des tarifs très attractifs. Le tarif moyen tourne autour de 65 € la nuit, parfait pour des biens familiaux à fort taux d'occupation.",
      serviceText: "Notre City Manager basé sur la Côte d'Émeraude couvre Ploubalay, Lancieux, Saint-Jacut et tout le secteur Beaussais-sur-Mer. Nous valorisons votre bien comme un camp de base idéal pour explorer la côte (Cap Fréhel, fort la Latte, Saint-Malo). Photos lumineuses, livret d'accueil orienté plages familiales et balades. Tarification ajustée à la saison et aux vacances scolaires.",
    },
    benefits: baseBenefits, differentiators: baseDifferentiators, stats: baseStats,
  },
  "saint-cast-le-guildo": {
    slug: "saint-cast-le-guildo", name: "Saint-Cast-le-Guildo", department: "22", region: "Côtes-d'Armor, Côte d'Émeraude",
    heroImage: CITY_IMG.saintCast, introImage: IMG.bretagneCoast,
    intro: {
      avgPrice: "85 €", travelers: "55 000+", tgv: "2h45 de Paris (via Saint-Malo)",
      text: "Élue parmi les plus belles plages d'Europe, la Grande Plage de Saint-Cast s'étire sur 2 km de sable fin. Station balnéaire familiale et chic, la commune offre golf 18 trous, casino, port de plaisance, marché animé. Plus de 55 000 voyageurs Airbnb par an et un tarif moyen de 85 € la nuit en font une destination très rentable, particulièrement de mai à septembre.",
      serviceText: "Saint-Cast est notre fief sur la Côte d'Émeraude. Nous mettons en avant les atouts station (plages, golf, casino) et activités outdoor (sentier des douaniers, plongée, voile). Photos qui captent la lumière atlantique, livret d'accueil avec adresses du marché et restaurants face mer. Tarification dynamique calée sur le festival, les régates et les événements golf.",
    },
    benefits: baseBenefits, differentiators: baseDifferentiators, stats: baseStats,
  },
  lancieux: {
    slug: "lancieux", name: "Lancieux", department: "22", region: "Côtes-d'Armor, Côte d'Émeraude",
    heroImage: CITY_IMG.lancieux, introImage: IMG.saintMalo,
    intro: {
      avgPrice: "78 €", travelers: "20 000+", tgv: "2h45 de Paris (via Saint-Malo)",
      text: "Petite station balnéaire confidentielle, Lancieux séduit par sa Grande Plage de sable fin (1,5 km), son moulin à vent emblématique et son ambiance familiale. Spot de char à voile et de surf, la commune attire 20 000 voyageurs par an. Tarif moyen 78 € la nuit avec une saison qui s'étire d'avril à octobre grâce au climat doux de la Côte d'Émeraude.",
      serviceText: "Lancieux = positionnement « plage familiale et authentique ». Nous valorisons la proximité immédiate de la mer, le moulin emblématique, les sentiers GR34 vers Saint-Briac. Annonces qui parlent aux familles avec enfants et aux amateurs de sports nautiques. Notre équipe est présente à 5 minutes pour les check-in physiques.",
    },
    benefits: baseBenefits, differentiators: baseDifferentiators, stats: baseStats,
  },
  "saint-jacut-de-la-mer": {
    slug: "saint-jacut-de-la-mer", name: "Saint-Jacut-de-la-Mer", department: "22", region: "Côtes-d'Armor, Côte d'Émeraude",
    heroImage: CITY_IMG.saintJacut, introImage: IMG.bretagneCoast,
    intro: {
      avgPrice: "80 €", travelers: "18 000+", tgv: "2h45 de Paris (via Saint-Malo)",
      text: "Presqu'île unique entre baie de l'Arguenon et baie de Lancieux, Saint-Jacut-de-la-Mer offre 11 plages, des panoramas exceptionnels et la fameuse île des Hébihens accessible à marée basse. Capitale ostréicole, la commune attire 18 000 voyageurs Airbnb par an. Tarif moyen 80 € la nuit, avec une saison étendue grâce à l'attrait des grandes marées et des paysages.",
      serviceText: "Saint-Jacut, c'est l'authentique Bretagne maritime. Nous mettons en lumière les 11 plages, l'île des Hébihens et la culture ostréicole locale. Photos en extérieur (marées, presqu'île), livret d'accueil avec horaires des marées et adresses ostréiculteurs. Tarification optimisée pour les grandes marées (équinoxe, vacances).",
    },
    benefits: baseBenefits, differentiators: baseDifferentiators, stats: baseStats,
  },
  matignon: {
    slug: "matignon", name: "Matignon", department: "22", region: "Côtes-d'Armor, Pays de Matignon",
    heroImage: CITY_IMG.matignon, introImage: IMG.bretagneCoast,
    intro: {
      avgPrice: "60 €", travelers: "8 500+", tgv: "2h45 de Paris (via Saint-Malo)",
      text: "Bourg historique au cœur de la baie de la Frênaye, Matignon a donné son nom au célèbre hôtel parisien. Marché animé tous les samedis, manoirs, proximité immédiate de Saint-Cast (5 km) et du Cap Fréhel (15 km). À 60 € la nuit en moyenne, la commune offre un excellent rapport qualité-prix pour des maisons de caractère.",
      serviceText: "Matignon = positionnement « charme rural & proximité côte ». Nous valorisons les pierres et les volumes des maisons traditionnelles, la proximité du Cap Fréhel et de Saint-Cast pour les activités, et le marché du samedi. Notre équipe locale assure check-in physique et maintenance avec une intervention sous 30 minutes.",
    },
    benefits: baseBenefits, differentiators: baseDifferentiators, stats: baseStats,
  },
  crehen: {
    slug: "crehen", name: "Créhen", department: "22", region: "Côtes-d'Armor, Vallée de l'Arguenon",
    heroImage: CITY_IMG.crehen, introImage: IMG.cozyInterior,
    intro: {
      avgPrice: "62 €", travelers: "6 500+", tgv: "2h45 de Paris (via Saint-Malo)",
      text: "Au bord de l'estuaire de l'Arguenon, Créhen abrite l'un des plus beaux sites médiévaux de la côte : le château du Guildo, en ruines romantiques face à la mer. Village paisible avec port d'échouage, GR34, accès rapide aux plages de Saint-Cast et Saint-Jacut. Tarif moyen 62 € la nuit, idéal pour qui cherche le calme à 5 minutes de la côte.",
      serviceText: "Créhen séduit par son authenticité. Nous orientons les annonces vers le château du Guildo, l'estuaire de l'Arguenon, les passages d'oiseaux migrateurs. Photos qui captent le jeu des marées et la lumière du soir. Notre City Manager couvre Créhen et tout le secteur Beaussais-sur-Mer / Saint-Cast.",
    },
    benefits: baseBenefits, differentiators: baseDifferentiators, stats: baseStats,
  },
  plancoet: {
    slug: "plancoet", name: "Plancoët", department: "22", region: "Côtes-d'Armor, Vallée de l'Arguenon",
    heroImage: CITY_IMG.plancoet, introImage: IMG.bretagneCoast,
    intro: {
      avgPrice: "58 €", travelers: "7 000+", tgv: "2h45 de Paris (via Saint-Malo)",
      text: "Connue pour sa source d'eau minérale Plancoët, la commune offre une ambiance de petite ville bretonne authentique : marché, halles, port fluvial sur l'Arguenon, sentier de halage vers Saint-Lormel. À 12 km des plages de Saint-Cast et Saint-Jacut, Plancoët séduit pour des séjours nature à petit prix. Tarif moyen 58 € la nuit.",
      serviceText: "Plancoët = positionnement « authentique et accessible ». Nous valorisons le patrimoine local (église, halles, port), la proximité de la côte, et les activités nature (canoë sur l'Arguenon, randonnées). Annonces qui ciblent voyageurs en quête d'authenticité et budgets maîtrisés. Linge fourni, ménage soigné, accueil 7j/7.",
    },
    benefits: baseBenefits, differentiators: baseDifferentiators, stats: baseStats,
  },
  "saint-lormel": {
    slug: "saint-lormel", name: "Saint-Lormel", department: "22", region: "Côtes-d'Armor, Vallée de l'Arguenon",
    heroImage: CITY_IMG.saintLormel, introImage: IMG.cozyInterior,
    intro: {
      avgPrice: "58 €", travelers: "5 500+", tgv: "2h45 de Paris (via Saint-Malo)",
      text: "Petite commune paisible à 3 minutes de Plancoët et 12 minutes des plages de Saint-Cast, Saint-Lormel séduit par son cadre verdoyant entre vallée de l'Arguenon et côte d'Émeraude. Ses chemins de halage, son patrimoine rural en pierre et la proximité immédiate des sources Plancoët en font une base idéale pour des séjours nature à petit prix. Tarif moyen 58 € la nuit, 5 500+ voyageurs Airbnb par an. Une porte d'entrée discrète et économique sur la Côte d'Émeraude.",
      serviceText: "Saint-Lormel = positionnement « authentique campagnard, à 10 min de la mer ». Nous valorisons les longères en pierre et les jardins typiques bretons, la proximité du port fluvial de Plancoët, des plages de Saint-Cast et de Saint-Jacut. Photos qui captent l'atmosphère « slow tourism » et l'arrière-pays préservé. Tarification dynamique calibrée sur les flux côtiers et les week-ends de randonnée. Notre City Manager couvre Saint-Lormel, Plancoët et Créhen avec une intervention en 15 minutes.",
    },
    benefits: baseBenefits, differentiators: baseDifferentiators, stats: baseStats,
  },
  languenan: {
    slug: "languenan", name: "Languenan", department: "22", region: "Côtes-d'Armor, Pays de Plancoët-Plélan",
    heroImage: CITY_IMG.languenan, introImage: IMG.cozyInterior,
    intro: {
      avgPrice: "55 €", travelers: "4 800+", tgv: "2h45 de Paris (via Saint-Malo)",
      text: "Bourg patrimonial à 8 minutes de Plancoët et 20 minutes de Dinan, Languenan abrite l'une des plus anciennes églises romanes de Bretagne (XIIᵉ siècle, classée Monument Historique). Cette commune confidentielle de l'arrière-pays plélanais offre un cadre rural préservé, à mi-chemin entre la mer (15 min de Saint-Cast) et la cité médiévale de Dinan. Idéale pour des voyageurs en quête de calme, de patrimoine et de bons plans. Tarif moyen 55 € la nuit, 4 800+ voyageurs Airbnb par an.",
      serviceText: "Languenan = positionnement « patrimoine breton authentique ». Nous valorisons l'église romane, les longères, les bocages et le réseau de chemins de randonnée. Annonces qui ciblent les passionnés d'histoire, les couples en escapade et les familles en quête d'autonomie. Tarification calée sur les pics Dinan / Côte d'Émeraude (printemps, été, vacances scolaires) avec un excellent rapport qualité-prix qui maximise le taux d'occupation. Linge fourni, ménage soigné, City Manager local.",
    },
    benefits: baseBenefits, differentiators: baseDifferentiators, stats: baseStats,
  },
  "pleudihen-sur-rance": {
    slug: "pleudihen-sur-rance", name: "Pleudihen-sur-Rance", department: "22", region: "Côtes-d'Armor, Vallée de la Rance",
    heroImage: CITY_IMG.pleudihen, introImage: IMG.bretagneCoast,
    intro: {
      avgPrice: "70 €", travelers: "9 500+", tgv: "2h45 de Paris (via Saint-Malo)",
      text: "Joyau confidentiel de la vallée de la Rance, Pleudihen-sur-Rance s'étire entre falaises boisées et eaux saumâtres, à 15 minutes de Dinan et 25 minutes de Saint-Malo. Port-Saint-Jean, sa cale de cidre et ses chemins de halage offrent un panorama typique « entre terre et mer ». Le sentier des douaniers (GR34) longe la commune, et les producteurs locaux (cidre, pommé) en font une étape gourmande. Tarif moyen 70 € la nuit, 9 500+ voyageurs Airbnb par an. Une parenthèse hors du temps à 1h30 de Paris en train.",
      serviceText: "Pleudihen-sur-Rance = positionnement « cocon nature au cœur de la Rance ». Nous valorisons les vues sur les marées, les chemins de halage, le patrimoine cidricole et les villages alentour (Dinan, Saint-Suliac, Léhon). Photos qui captent les jeux de lumière sur la Rance, livret d'accueil avec circuits cidre / kayak / GR34. Tarification dynamique calée sur les festivals de Dinan, les week-ends de la Saint-Patrick et les saisons cidricoles. Notre City Manager couvre Pleudihen, Saint-Suliac, La Vicomté-sur-Rance et Léhon avec intervention en 20 minutes.",
    },
    benefits: baseBenefits, differentiators: baseDifferentiators, stats: baseStats,
  },
  corseul: {
    slug: "corseul", name: "Corseul", department: "22", region: "Côtes-d'Armor, Pays de Dinan",
    heroImage: CITY_IMG.corseul, introImage: IMG.cozyInterior,
    intro: {
      avgPrice: "62 €", travelers: "7 200+", tgv: "2h45 de Paris (via Saint-Malo)",
      text: "Ancienne capitale de la cité gallo-romaine des Coriosolites, Corseul est l'un des plus beaux secrets historiques de Bretagne. Le temple de Mars (Haut Bécherel), les vestiges du forum, le musée de la Société archéologique et son église Saint-Pierre au clocher emblématique racontent 2 000 ans d'histoire à 12 minutes de Dinan et 30 minutes de la mer. Bourg paisible, marché du dimanche animé, restaurants gastronomiques (« Le Val de Gravel »), Corseul attire les voyageurs amateurs d'histoire, de patrimoine et de tranquillité. Tarif moyen 62 € la nuit, 7 200+ voyageurs Airbnb par an.",
      serviceText: "Corseul = positionnement « patrimoine vivant à 30 min de la mer ». Nous valorisons l'héritage gallo-romain unique en Bretagne, les volumes des longères en pierre et la proximité immédiate de Dinan, Lamballe et de la Côte d'Émeraude. Photos qui captent l'ambiance « village d'histoire chic », livret d'accueil avec circuits archéologiques, marchés et tables locales. Tarification dynamique calée sur les Médiévales de Dinan et les week-ends culturels. Notre City Manager couvre Corseul, Plancoët, Languenan et Trédias avec une intervention en moins de 20 minutes.",
    },
    benefits: baseBenefits, differentiators: baseDifferentiators, stats: baseStats,
  },
  pluduno: {
    slug: "pluduno", name: "Pluduno", department: "22", region: "Côtes-d'Armor, Pays de Plancoët",
    heroImage: CITY_IMG.pluduno, introImage: IMG.cozyInterior,
    intro: {
      avgPrice: "60 €", travelers: "6 800+", tgv: "2h45 de Paris (via Saint-Malo)",
      text: "Niché entre la vallée de l'Arguenon et les premières terres de la Côte d'Émeraude, Pluduno conserve un patrimoine rural exceptionnel : manoirs, longères, fontaines, lavoirs et le célèbre château de la Bouëxière. À 5 minutes de Plancoët, 12 minutes des plages de Saint-Cast et 25 minutes de Dinan, Pluduno offre un cadre privilégié pour des séjours nature, sportifs (golf de Pen Guen, randonnées GR34) ou patrimoniaux. Tarif moyen 60 € la nuit, 6 800+ voyageurs Airbnb par an. Un excellent rapport qualité/prix pour rayonner sur le 22.",
      serviceText: "Pluduno = positionnement « pied-à-terre patrimonial » entre mer et campagne. Nous valorisons les manoirs et longères en pierre, la proximité immédiate des sources Plancoët et de la côte. Photos qui captent les volumes, les jardins typiques bretons et la lumière douce de l'arrière-pays. Livret d'accueil avec circuits Saint-Cast / Dinan / Cap Fréhel et adresses confidentielles (golfs, marchés, producteurs cidricoles). Tarification dynamique calée sur les flux côtiers et les vacances scolaires. Notre City Manager couvre Pluduno, Plancoët, Saint-Lormel et Saint-Cast avec une intervention en 15 minutes.",
    },
    benefits: baseBenefits, differentiators: baseDifferentiators, stats: baseStats,
  },
  "saint-jouan-des-guerets": {
    slug: "saint-jouan-des-guerets", name: "Saint-Jouan-des-Guérets", department: "35", region: "Ille-et-Vilaine, Pays Malouin",
    heroImage: CITY_IMG.saintJouan, introImage: IMG.saintMalo,
    intro: {
      avgPrice: "68 €", travelers: "14 000+", tgv: "2h15 de Paris (via Saint-Malo)",
      text: "À 10 minutes de Saint-Malo, Saint-Jouan-des-Guérets bénéficie d'un emplacement stratégique : porte d'entrée de la cité corsaire, accès direct à la baie. Plus calme et plus abordable que Saint-Malo, la commune attire les familles et les voyageurs qui cherchent le bon compromis prix / proximité. Tarif moyen 68 € la nuit.",
      serviceText: "Nous positionnons votre bien comme « la bonne alternative à Saint-Malo » : tranquillité + accès rapide. Photos lumineuses, descriptifs orientés famille/famille élargie. Notre City Manager intervient en moins de 30 minutes. Tarification calibrée sur Saint-Malo avec une décote attractive pour booster les réservations.",
    },
    benefits: baseBenefits, differentiators: baseDifferentiators, stats: baseStats,
  },
  pleurtuit: {
    slug: "pleurtuit", name: "Pleurtuit", department: "35", region: "Ille-et-Vilaine, Rive sud de la Rance",
    heroImage: CITY_IMG.pleurtuit, introImage: IMG.bretagneCoast,
    intro: {
      avgPrice: "75 €", travelers: "12 000+", tgv: "Saint-Malo TGV (15 min) · Paris en 2h25",
      text: "À 5 minutes de Dinard et 15 minutes de Saint-Malo, Pleurtuit allie campagne bretonne et accès direct à la Côte d'Émeraude. La commune offre un cadre paisible avec ses bords de Rance, ses moulins à marée (Moulin du Prat, écluse du Châtelier) et son patrimoine en pierre. Idéal pour des voyageurs qui cherchent calme, espace et proximité immédiate des plages. Tarif moyen 75 € la nuit.",
      serviceText: "Pleurtuit = positionnement « campagne chic à 5 min de la mer ». Nous valorisons la proximité immédiate de Dinard, les bords de Rance et les balades GR34 vers Le Minihic-sur-Rance. Photos qui captent les volumes des longères et l'atmosphère bretonne authentique. Tarification dynamique calée sur les événements de Dinard (Festival du film britannique, Open de golf). Notre City Manager basé à Pleurtuit même intervient en moins de 10 minutes.",
    },
    benefits: baseBenefits, differentiators: baseDifferentiators, stats: baseStats,
  },
  "saint-briac-sur-mer": {
    slug: "saint-briac-sur-mer", name: "Saint-Briac-sur-Mer", department: "35", region: "Ille-et-Vilaine, Côte d'Émeraude",
    heroImage: CITY_IMG.saintBriac, introImage: IMG.bretagneCoast,
    intro: {
      avgPrice: "92 €", travelers: "22 000+", tgv: "2h30 de Paris (via Saint-Malo)",
      text: "Petite station balnéaire chic et confidentielle entre Dinard et Lancieux, Saint-Briac-sur-Mer est l'un des secrets les mieux gardés de la Côte d'Émeraude. Plages familiales (Salinette, Béchet, Port-Hue, Longchamp), golf 18 trous Dinard-Saint-Briac (le 2ᵉ plus ancien du continent), port de plaisance pittoresque et villas Belle Époque : 8 km de littoral préservé entre falaises rouges et criques de sable fin. Plus de 22 000 voyageurs Airbnb par an, tarif moyen de 92 € la nuit, avec une saison qui s'étire d'avril à octobre grâce à un microclimat exceptionnel. Le château du Nessay et le port à marée basse sont devenus des spots Insta incontournables.",
      serviceText: "Saint-Briac est notre fief sur la pointe ouest de la Côte d'Émeraude. Nous valorisons votre bien à travers les codes du « village d'artistes chic » qu'a immortalisé Renoir : photos en lumière dorée, livret d'accueil avec accès golf, criques secrètes du sentier des douaniers (GR34), tables iodées (Le Bénétin, La Vieille Auberge) et marchés du dimanche. Tarification dynamique calibrée sur le festival des arts de Saint-Briac, les régates, les Open de golf et les vacances scolaires britanniques (très prisé des Anglais). Notre City Manager couvre Saint-Briac, Lancieux et Saint-Lunaire avec une intervention en 10 minutes.",
    },
    benefits: baseBenefits, differentiators: baseDifferentiators, stats: baseStats,
  },
  "chateauneuf-d-ille-et-vilaine": {
    slug: "chateauneuf-d-ille-et-vilaine", name: "Châteauneuf-d'Ille-et-Vilaine", department: "35", region: "Ille-et-Vilaine, Pays de Saint-Malo",
    heroImage: CITY_IMG.chateauneuf, introImage: IMG.saintMalo,
    intro: {
      avgPrice: "72 €", travelers: "9 000+", tgv: "2h15 de Paris (gare Saint-Malo)",
      text: "À 12 minutes de Saint-Malo et 25 minutes du Mont-Saint-Michel, Châteauneuf-d'Ille-et-Vilaine est une commune authentique de l'arrière-pays malouin, à mi-chemin entre la mer et la baie. Son patrimoine en pierre, Mairie classée, Justice de Paix, lavoirs, anciennes fermes, séduit les voyageurs en quête de charme rural breton. Plus calme et bien plus abordable que la cité corsaire, Châteauneuf attire les familles et les couples qui veulent rayonner sur Saint-Malo, Cancale, Dol et le Mont-Saint-Michel sans subir la pression touristique. Tarif moyen 72 € la nuit, 9 000+ voyageurs Airbnb par an.",
      serviceText: "Châteauneuf est notre carte joker pour les biens spacieux à prix doux. Nous positionnons votre logement comme « le pied-à-terre stratégique 4-couronnes » : Saint-Malo, Cancale, Dinan et Mont-Saint-Michel à moins de 30 minutes. Photos qui mettent en valeur les volumes, les pierres apparentes et les jardins. Livret d'accueil avec itinéraires sur mesure (huîtres à Cancale, remparts de Saint-Malo, Mont-Saint-Michel à marée haute). Tarification dynamique calée sur les flux Mont-Saint-Michel, un atout invisible pour la concurrence. Notre City Manager intervient en moins de 25 minutes.",
    },
    benefits: baseBenefits, differentiators: baseDifferentiators, stats: baseStats,
  },
  "saint-benoit-des-ondes": {
    slug: "saint-benoit-des-ondes", name: "Saint-Benoît-des-Ondes", department: "35", region: "Ille-et-Vilaine, Baie du Mont-Saint-Michel",
    heroImage: CITY_IMG.saintBenoit, introImage: IMG.bretagneCoast,
    intro: {
      avgPrice: "78 €", travelers: "11 000+", tgv: "2h15 de Paris (gare Saint-Malo)",
      text: "Petit village ostréicole face à la baie du Mont-Saint-Michel, entre Cancale et Saint-Malo, Saint-Benoît-des-Ondes est une pépite confidentielle qui séduit les amateurs d'authenticité bretonne. Maisons de pêcheurs en pierre, sentier littoral à perte de vue, dégustation d'huîtres directement chez les producteurs, vue panoramique sur le Mont-Saint-Michel les jours de grande marée : un cadre privilégié, calme et iodé. Tarif moyen 78 € la nuit, 11 000+ voyageurs Airbnb par an, avec une demande qui explose au printemps et à l'automne (grandes marées et pèlerinages).",
      serviceText: "Saint-Benoît-des-Ondes est notre vitrine pour le tourisme expérientiel. Nous valorisons votre bien autour de l'art de vivre breton : photos qui captent la lumière de baie, livret d'accueil avec adresses confidentielles (huîtres Lemarié, randos GR34, traversée à pied vers le Mont-Saint-Michel), kit d'accueil produits du terroir. Tarification dynamique calée sur les grandes marées (calendrier publié 2 ans à l'avance, prime jusqu'à +40%) et les événements du Mont-Saint-Michel. Notre City Manager couvre Saint-Benoît, Cancale et Saint-Méloir avec une intervention en moins de 15 minutes.",
    },
    benefits: baseBenefits, differentiators: baseDifferentiators, stats: baseStats,
  },
  "la-richardais": {
    slug: "la-richardais", name: "La Richardais", department: "35", region: "Ille-et-Vilaine, Rive sud de la Rance",
    heroImage: CITY_IMG.laRichardais, introImage: IMG.bretagneCoast,
    intro: {
      avgPrice: "72 €", travelers: "9 000+", tgv: "2h45 de Paris",
      text: "Face à Dinard, sur la rive sud de la Rance, La Richardais offre une vue imprenable sur l'usine marémotrice et l'estuaire. Petite commune paisible avec port de plaisance, sentiers côtiers et accès rapide à Saint-Malo et Dinard, elle séduit les amateurs de nature et les couples. Tarif moyen 72 € la nuit.",
      serviceText: "La Richardais = positionnement vue Rance et calme. Nous valorisons la position face à Dinard et la proximité du barrage de la Rance (visites guidées). Photos qui captent les couchers de soleil sur l'estuaire. Tarification optimisée week-end et saison estivale, avec décote intelligente pour les longs séjours.",
    },
    benefits: baseBenefits, differentiators: baseDifferentiators, stats: baseStats,
  },
  "le-minihic-sur-rance": {
    slug: "le-minihic-sur-rance", name: "Le Minihic-sur-Rance", department: "35", region: "Ille-et-Vilaine, Rive sud de la Rance",
    heroImage: CITY_IMG.leMinihic, introImage: IMG.saintMalo,
    intro: {
      avgPrice: "68 €", travelers: "7 500+", tgv: "2h45 de Paris",
      text: "Village authentique de la rive sud de la Rance, Le Minihic-sur-Rance préserve son cachet de port maritime du XIXe siècle. Cale de la Landriais, anciens chantiers navals, sentiers du GR34 vers la Pointe du Grouin du Sud : la commune attire les voyageurs en quête d'un séjour vrai, loin des foules. Tarif moyen 68 € la nuit.",
      serviceText: "Le Minihic est un secret bien gardé. Nous le révélons aux voyageurs Airbnb avec des annonces qui racontent l'histoire maritime du village, des photos en extérieur (cale, voiliers, sentiers) et un livret d'accueil tourné vers la nature et le terroir. Notre équipe locale est présente et réactive.",
    },
    benefits: baseBenefits, differentiators: baseDifferentiators, stats: baseStats,
  },
  // ============================================================
  // === Morbihan (56), Équipe Sud Bretagne (Damgan / La Roche-Bernard)
  // ============================================================
  damgan: {
    slug: "damgan", name: "Damgan", department: "56", region: "Morbihan, Côte sauvage de Pénerf",
    heroImage: CITY_IMG.damgan, introImage: IMG.bretagneCoast,
    geo: { lat: 47.5167, lng: -2.5833 },
    postalCode: "56750",
    intro: {
      avgPrice: "88 €", travelers: "42 000+", tgv: "3h30 de Paris (gare de Vannes)",
      text: "Station balnéaire familiale et dynamique de la côte sud du Morbihan, Damgan séduit avec ses 7 km de plages de sable fin (Kervoyal, Damgan-centre, Pénerf), son port ostréicole pittoresque et son sentier des douaniers (GR34) en bord de mer. À 30 minutes de Vannes et du golfe du Morbihan, à 40 minutes de Belle-Île-en-Mer (départ Quiberon), Damgan attire chaque année plus de 42 000 voyageurs Airbnb. Tarif moyen 88 € la nuit avec une saison qui s'étire d'avril à octobre grâce au microclimat exceptionnel et aux 7 plages exposées plein sud.",
      serviceText: "Damgan est notre fief sur la côte morbihannaise. Notre équipe locale du 56 valorise votre bien autour des codes « plage familiale chic » : photos qui captent la lumière atlantique sud, livret d'accueil avec parcours huîtres de Pénerf, marchés (Damgan le mercredi/dimanche), GR34 et excursions vers le golfe du Morbihan. Tarification dynamique calée sur les vacances scolaires, les régates de Pénerf et les festivals d'été. Notre équipe Sud Bretagne intervient en moins de 15 minutes sur Damgan, Ambon, Pénerf et Billiers.",
    },
    benefits: baseBenefits, differentiators: baseDifferentiators, stats: baseStats,
  },
  "la-roche-bernard": {
    slug: "la-roche-bernard", name: "La Roche-Bernard", department: "56", region: "Morbihan, Vallée de la Vilaine",
    heroImage: CITY_IMG.laRocheBernard, introImage: IMG.cozyInterior,
    geo: { lat: 47.5197, lng: -2.3036 },
    postalCode: "56130",
    intro: {
      avgPrice: "82 €", travelers: "28 000+", tgv: "3h15 de Paris (gare de Redon)",
      text: "Classée « Petite Cité de Caractère » et « Plus Beaux Détours de France », La Roche-Bernard est un joyau perché au-dessus de la Vilaine. Son port de plaisance accueille plus de 700 bateaux, son centre historique aux ruelles pavées, ses maisons à pans de bois (XVIᵉ-XVIIᵉ siècles) et sa vue panoramique sur l'estuaire en font une destination courue toute l'année. À 25 minutes de Damgan, 35 minutes de Vannes, 45 minutes de Nantes, La Roche-Bernard attire 28 000 voyageurs Airbnb par an. Tarif moyen 82 € la nuit, avec des pics lors des Semaines du Golfe et des fêtes maritimes.",
      serviceText: "La Roche-Bernard demande une approche premium « patrimoine vivant ». Photos qui captent les pierres et le port à la lumière dorée, annonces rédigées en français/anglais (clientèle britannique des plaisanciers), livret d'accueil orienté patrimoine (musée de la Vilaine maritime, château de Léhélec) et adresses gastronomiques (L'Auberge Bretonne**). Tarification calée sur les régates, salons nautiques et marchés de Noël. Notre équipe Sud Bretagne intervient en moins de 20 minutes.",
    },
    benefits: baseBenefits, differentiators: baseDifferentiators, stats: baseStats,
  },
  ambon: {
    slug: "ambon", name: "Ambon", department: "56", region: "Morbihan, Presqu'île de Rhuys & Pénerf",
    heroImage: CITY_IMG.ambon, introImage: IMG.bretagneCoast,
    geo: { lat: 47.5500, lng: -2.5500 },
    postalCode: "56190",
    intro: {
      avgPrice: "76 €", travelers: "18 500+", tgv: "3h30 de Paris (gare de Vannes)",
      text: "Voisine immédiate de Damgan, Ambon offre un cadre rural authentique entre marais salants, bocage et plages familiales (Bétahon, Lanedan, Brouel). Son riche patrimoine, vestiges médiévaux, anciennes longères en pierre, chapelle Notre-Dame-des-Vertus, séduit les voyageurs en quête d'authenticité. À 5 minutes des plages de Damgan, 25 minutes de Vannes et du golfe du Morbihan, Ambon attire plus de 18 500 voyageurs Airbnb par an. Tarif moyen 76 € la nuit, avec un excellent rapport qualité/prix qui maximise le taux d'occupation.",
      serviceText: "Ambon = positionnement « campagne authentique à 5 min de la mer ». Nous valorisons les longères en pierre et les jardins typiques bretons, la proximité immédiate de la plage de Bétahon (port d'échouage emblématique) et des sentiers de marais. Photos qui captent les volumes et la lumière du Sud-Bretagne, livret d'accueil avec circuits ostréicoles (Pénerf), GR34 et golfe du Morbihan. Notre équipe Sud Bretagne couvre Ambon, Damgan, Billiers et Muzillac avec une intervention en moins de 15 minutes.",
    },
    benefits: baseBenefits, differentiators: baseDifferentiators, stats: baseStats,
  },
  marzan: {
    slug: "marzan", name: "Marzan", department: "56", region: "Morbihan, Vallée de la Vilaine",
    heroImage: CITY_IMG.marzan, introImage: IMG.cozyInterior,
    geo: { lat: 47.5333, lng: -2.3667 },
    postalCode: "56190",
    intro: {
      avgPrice: "62 €", travelers: "9 500+", tgv: "3h15 de Paris (gare de Redon)",
      text: "Bourg paisible à 5 minutes de La Roche-Bernard et 20 minutes de Damgan, Marzan est un excellent pied-à-terre pour rayonner sur le Sud-Morbihan : Vilaine, plages de la baie, golfe du Morbihan, Brière et Guérande à 30 minutes. Commune dynamique avec écoles, commerces et marchés, Marzan séduit par son cadre rural et son accès direct à la 4-voies (N165). Tarif moyen 62 € la nuit, 9 500+ voyageurs Airbnb par an : un excellent rapport qualité/prix pour des biens spacieux.",
      serviceText: "Marzan = positionnement « pied-à-terre stratégique 4-couronnes » : La Roche-Bernard, Damgan, golfe du Morbihan et Brière à moins de 30 minutes. Nous valorisons les longères et maisons familiales, leurs jardins et leur tranquillité. Photos qui mettent en avant les volumes et la luminosité, livret d'accueil avec itinéraires sur mesure (cités de caractère, plages, marais). Tarification dynamique calée sur les flux côtiers et les vacances scolaires. Notre équipe Sud Bretagne intervient en moins de 15 minutes.",
    },
    benefits: baseBenefits, differentiators: baseDifferentiators, stats: baseStats,
  },
  peaule: {
    slug: "peaule", name: "Péaule", department: "56", region: "Morbihan, Pays de la Vilaine",
    heroImage: CITY_IMG.peaule, introImage: IMG.cozyInterior,
    geo: { lat: 47.6372, lng: -2.3433 },
    postalCode: "56130",
    intro: {
      avgPrice: "58 €", travelers: "7 200+", tgv: "3h15 de Paris (gare de Redon)",
      text: "Niché dans la verdure entre La Roche-Bernard (10 min) et Vannes (25 min), Péaule conserve un patrimoine rural exceptionnel : vieux bourg en pierre, crêperies traditionnelles, chapelles, calvaires et chemins creux. Cadre privilégié pour des séjours nature, Péaule offre un excellent rapport qualité/prix pour les voyageurs qui souhaitent rayonner sur le Sud-Morbihan tout en profitant du calme. Tarif moyen 58 € la nuit, 7 200+ voyageurs Airbnb par an, avec une demande qui explose en été et lors des grands événements (Semaines du Golfe, Fest-Noz).",
      serviceText: "Péaule = positionnement « cocon rural au cœur du Sud-Morbihan ». Nous valorisons les longères en pierre, les volumes et l'authenticité du Vieux Bourg. Photos qui captent la lumière douce de l'arrière-pays, livret d'accueil avec adresses confidentielles (crêperies, marchés, cidre fermier) et circuits vers La Roche-Bernard, Damgan, golfe du Morbihan. Tarification calibrée sur les flux côtiers et les vacances scolaires. Notre équipe Sud Bretagne couvre Péaule, La Roche-Bernard, Marzan et Nivillac avec une intervention en moins de 15 minutes.",
    },
    benefits: baseBenefits, differentiators: baseDifferentiators, stats: baseStats,
  },
  muzillac: {
    slug: "muzillac", name: "Muzillac", department: "56", region: "Morbihan, Pays de Muzillac",
    heroImage: CITY_IMG.muzillac, introImage: IMG.bretagneCoast,
    geo: { lat: 47.5611, lng: -2.4778 },
    postalCode: "56190",
    intro: {
      avgPrice: "70 €", travelers: "14 500+", tgv: "3h30 de Paris (gare de Vannes)",
      text: "Capitale du Pays de Muzillac, cette petite ville dynamique offre un patrimoine remarquable (Office de tourisme dans une demeure historique en pierre, château de Pen Mur, chapelle de Bourg-Paul) et une situation stratégique : à 10 min des plages de Damgan et de la baie de Pénerf, à 15 min de La Roche-Bernard et de la Vilaine, à 25 min de Vannes et du golfe du Morbihan. Marchés animés, restaurants, services complets et accès direct à la 4-voies (N165) en font une base idéale pour explorer le Sud-Morbihan. Plus de 14 500 voyageurs Airbnb par an, tarif moyen 70 € la nuit, avec une saison qui s'étire d'avril à octobre.",
      serviceText: "Muzillac est notre carrefour stratégique sur le 56. Nous positionnons votre logement comme « pied-à-terre 4-couronnes » avec accès rapide aux plages (Damgan, Pénerf, Pénestin), au patrimoine (La Roche-Bernard, golfe du Morbihan), aux marchés et aux activités outdoor (GR34, kayak sur la Vilaine, Brière). Photos qui captent les pierres, les volumes et la lumière du Sud-Morbihan, livret d'accueil avec circuits sur mesure et adresses gourmandes. Tarification dynamique calée sur les vacances scolaires, les événements de Vannes et les flux côtiers. Notre équipe Sud Bretagne couvre Muzillac, Damgan, La Roche-Bernard, Marzan et Péaule avec une intervention en moins de 15 minutes.",
    },
    benefits: baseBenefits, differentiators: baseDifferentiators, stats: baseStats,
  },
};

export const CITY_CANCALE = CITIES_DATA.cancale;

export const FAQ_CATEGORIES = [
  { id: "demarrer", label: "Avant de commencer", icon: "Rocket" },
  { id: "exploitation", label: "Pendant la location", icon: "Calendar" },
  { id: "caution", label: "Caution & assurances", icon: "Shield" },
  { id: "tarifs", label: "Tarifs & revenus", icon: "Wallet" },
  { id: "fiscalite", label: "Fiscalité & déclaration", icon: "FileText" },
  { id: "reglementation", label: "Réglementation locale", icon: "Landmark" },
  { id: "service", label: "Service & disponibilité", icon: "Phone" },
];

export const FAQ_ITEMS = [
  // === Avant de commencer ===
  {
    cat: "demarrer",
    q: "Peut-on habiter le logement par intermittence ou le prêter à des proches ?",
    a: "L'intérêt principal de la location courte durée est la flexibilité. Nous convenons ensemble des dates auxquelles vous souhaitez conserver la jouissance de votre bien. Vos derniers locataires quittent les lieux, notre équipe passe faire le ménage et vous retrouvez votre chez-vous impeccable pour la durée de votre choix.",
  },
  {
    cat: "demarrer",
    q: "Puis-je louer sur Airbnb toute l'année ?",
    a: "Dans le cas d'une résidence secondaire, vous pouvez louer un logement sur Airbnb 365 jours par an. La limite des 120 jours ne s'applique qu'à votre résidence principale (et selon les communes : à Saint-Malo et Dinan, certains secteurs sont contingentés).",
  },
  {
    cat: "demarrer",
    q: "Combien de jeux de clés dois-je fournir ?",
    a: "Par mesure de sécurité, nous avons besoin de 2 jeux de clés à notre disposition. Ces jeux servent à nos concierges et à vos voyageurs (remise physique par notre City Manager local ou check-in autonome via boîte à clés sécurisée selon votre préférence).",
  },
  {
    cat: "demarrer",
    q: "Combien de temps pour mettre mon bien en ligne ?",
    a: "Nous prenons en charge l'intégralité du processus : visite + audit en J0, shooting photo professionnel sous 7 à 14 jours, rédaction et publication des annonces multi-plateformes (Airbnb, Booking, Vrbo) en 48h après réception des photos. Vos premières réservations arrivent généralement dans les 10 jours suivant la mise en ligne.",
  },
  {
    cat: "demarrer",
    q: "Mon bien doit-il déjà être meublé ou pouvez-vous m'aider ?",
    a: "Idéalement votre bien est déjà équipé. Si ce n'est pas le cas, nous proposons un forfait équipement clé-en-main à partir de 890 € TTC (achat, livraison et mise en place de l'ensemble des équipements obligatoires + touches bretonnes signature). Combo Conciergerie + Équipement = -30 % sur le forfait équipement.",
  },
  {
    cat: "demarrer",
    q: "Quelles villes couvrez-vous ?",
    a: "Nous opérons sur 30 communes réparties en 3 départements : Ille-et-Vilaine (Saint-Malo, Cancale, Dinard, Saint-Briac, Saint-Lunaire, Pleurtuit, Dol-de-Bretagne…), Côtes-d'Armor (Dinan, Saint-Cast-le-Guildo, Lancieux, Plancoët, Matignon…) et Morbihan (Damgan, La Roche-Bernard, Ambon, Marzan, Péaule, Muzillac). Voir la carte interactive complète sur notre page Villes.",
  },

  // === Pendant la location ===
  {
    cat: "exploitation",
    q: "Puis-je avoir un œil sur les réservations ?",
    a: "Oui. Vous avez accès depuis votre espace propriétaire TERRE ET MER aux réservations, montants payés par les voyageurs, durée de location, calendrier et historique en temps réel.",
  },
  {
    cat: "exploitation",
    q: "Comment puis-je communiquer avec les voyageurs ?",
    a: "Notre travail consiste à vous décharger des échanges parfois répétitifs avec les voyageurs. Les annonces sont gérées directement depuis notre logiciel et nos équipes répondent 24h/24, 7j/7 (y compris la nuit grâce à notre permanence). Vous gardez bien sûr accès aux coordonnées des voyageurs depuis l'interface propriétaire si besoin.",
  },
  {
    cat: "exploitation",
    q: "Sélectionnez-vous les voyageurs ?",
    a: "Oui. Nous vérifions systématiquement les avis et l'identité des voyageurs lorsque la plateforme le permet. Notre objectif : préserver votre logement et garantir des séjours sereins. Toute réservation suspecte (profil neuf, motif flou, voyageur unique pour un grand logement…) fait l'objet d'un échange complémentaire avant validation.",
  },
  {
    cat: "exploitation",
    q: "Comment faire en cas de désordre auprès du voisinage ?",
    a: "Notre équipe de City Managers veille au bon respect du règlement intérieur de votre annonce Airbnb. Il s'agit avant tout d'éviter l'organisation de fêtes qui pourraient occasionner des nuisances. En cas de voyageur trop bruyant, nous pouvons intervenir et, si nécessaire, mettre un terme à la location.",
  },
  {
    cat: "exploitation",
    q: "Que se passe-t-il en cas de panne (chaudière, plomberie, électricité) ?",
    a: "Nous intervenons sous 30 à 60 minutes physiquement, et activons immédiatement notre réseau de partenaires artisans locaux (plombier, électricien, chauffagiste). Les petites maintenances sont facturées 15 €/h TTC, les interventions externes 30 €/h TTC. Nous vous tenons informé(e) en temps réel.",
  },
  {
    cat: "exploitation",
    q: "Comment se passe le ménage ?",
    a: "Notre équipe de ménagères salariées (pas de prestataires externes) intervient entre chaque séjour. Check-list en 47 points incluant : draps, salle de bain, cuisine, vitres, mobilier, jardin, électroménager. Les frais de ménage sont à la charge du voyageur (refacturé via la plateforme), donc neutres pour vous.",
  },

  // === Caution & assurances ===
  {
    cat: "caution",
    q: "Comment fonctionne la caution ?",
    a: "Sur la plateforme Airbnb il n'est pas possible de prendre une caution traditionnelle, mais la garantie « AirCover » vous couvre jusqu'à 1 000 000 €. En cas de dommage, nous contactons Airbnb au plus vite avant l'arrivée des locataires suivants, prenons des photos des dégradations et estimons le montant des réparations après vous avoir consulté. Sur Booking et Abritel, nous prenons une empreinte de carte entre 400 € et 1 500 € selon la taille du logement.",
  },
  {
    cat: "caution",
    q: "Suis-je couvert(e) par des assurances ?",
    a: "Les dommages sont couverts pour les réservations Airbnb selon les conditions de la plateforme (AirCover jusqu'à 1 000 000 €). Pour les autres canaux, nous vous accompagnons dans le choix d'une assurance complémentaire adaptée à la location courte durée (PNO + multirisque habitation locative).",
  },
  {
    cat: "caution",
    q: "Que faire si un voyageur dégrade le bien ?",
    a: "Notre City Manager constate les dégâts dès le check-out (photos datées, inventaire, devis sous 48h auprès de nos artisans partenaires). Nous montons le dossier auprès d'Airbnb (AirCover) ou prélevons l'empreinte CB Booking/Abritel. Vous êtes informé(e) à chaque étape et n'avez rien à gérer.",
  },
  {
    cat: "caution",
    q: "Mon bien risque-t-il d'être squatté en location courte durée ?",
    a: "Non. La location courte durée n'ouvre aucun droit au logement (pas de résidence principale du voyageur). En cas de refus de départ, extrêmement rare, nous activons une procédure d'expulsion en 48-72h via huissier, avec assistance juridique de notre partenaire avocat fiscaliste.",
  },

  // === Tarifs & revenus ===
  {
    cat: "tarifs",
    q: "Qui paie quoi ? Comment fonctionne la facturation ?",
    a: "Contrairement à nos concurrents, c'est VOUS qui encaissez directement tous les revenus Airbnb. En fin de mois, nous vous adressons une facture pour nos prestations : 15 % TTC en formule standard. Les frais de ménage sont à la charge du voyageur (refacturés via la plateforme). Le linge de lit et de toilette n'est PAS inclus : par défaut les voyageurs apportent le leur, ou ils peuvent souscrire l'option linge premium directement auprès de nous (facturée à eux, neutre pour vous).",
  },
  {
    cat: "tarifs",
    q: "Le linge de lit et de toilette est-il inclus dans la formule à 15 % ?",
    a: "Non. La formule à 15 % TTC ne comprend pas le linge de lit et de toilette. Par défaut, les voyageurs apportent leur propre linge, c'est précisé dans l'annonce et dans le livret d'accueil. S'ils préfèrent ne pas s'en occuper, ils peuvent souscrire notre option linge premium directement auprès de nous : draps-housses (jusqu'à 160×200 cm), housses de couette (jusqu'à 220×240 cm), taies d'oreiller et serviettes livrés et installés à leur arrivée. Cette option leur est facturée à eux, jamais à vous : votre revenu net n'est pas impacté.",
  },
  {
    cat: "tarifs",
    q: "Faites-vous de la conciergerie à la carte ?",
    a: "Oui. Au-delà de notre formule à 15 % TTC qui inclut tous les services essentiels (multidiffusion, pricing dynamique, communication 24/24, ménage, accueil, maintenance courante), nous adaptons la prestation : photos professionnelles supplémentaires, vidéo drone, livret d'accueil personnalisé, équipement clé-en-main, conseil fiscal LMNP, etc. Discutons-en lors d'un appel personnalisé.",
  },
  {
    cat: "tarifs",
    q: "Quels revenus puis-je espérer obtenir sur Airbnb ?",
    a: "Les revenus dépendent de nombreux paramètres : emplacement, capacité, équipements, qualité des photos, saisonnalité. À titre indicatif (revenu net annuel après commission 15 %) : T2 à Saint-Malo ≈ 28-32 k€, maison 4 chambres à Cancale ≈ 38-45 k€, mobile home à Damgan ≈ 12-16 k€. Utilisez notre simulateur IA pour une estimation précise en 2 minutes, ou demandez une étude gratuite personnalisée.",
  },
  {
    cat: "tarifs",
    q: "Y a-t-il des frais cachés ?",
    a: "Non. Notre tarif de 15 % TTC est tout-inclus pour la conciergerie courante (multidiffusion, pricing, communication 24/7, accueil, ménage planifié, maintenance courante). Le linge n'est pas inclus (option voyageur dédiée). Seuls les frais de mise en place initiale (équipement, photos) sont facturés à part, toujours sur devis détaillé et validé par vous au préalable. Aucune commission cachée, aucun frais de dossier, aucun frais d'arrêt.",
  },
  {
    cat: "tarifs",
    q: "Puis-je résilier à tout moment ?",
    a: "Oui. Notre contrat est à durée indéterminée avec préavis de 30 jours. Aucune pénalité de sortie, aucun engagement minimum. Nous misons sur la qualité de service et la confiance, pas sur les contraintes contractuelles.",
  },

  // === Fiscalité ===
  {
    cat: "fiscalite",
    q: "Faut-il déclarer les revenus Airbnb ?",
    a: "Oui. Comme tout revenu locatif, la location meublée en courte durée engendre impôts et prélèvements sociaux. Selon votre situation (LMNP au régime micro-BIC ou réel), nous pouvons vous orienter vers nos partenaires comptables spécialisés pour optimiser votre fiscalité.",
  },
  {
    cat: "fiscalite",
    q: "Quel statut fiscal choisir : micro-BIC ou régime réel LMNP ?",
    a: "Cela dépend de vos revenus et charges. Le micro-BIC offre depuis 2025 un abattement de 30 % (50 % si meublé classé en étoiles) avec un plafond limité. Le régime réel permet de déduire toutes les charges réelles (intérêts d'emprunt, amortissements, travaux, conciergerie…) et est souvent plus avantageux dès lors que vos revenus dépassent 15 k€/an. Notre partenaire fiscaliste vous oriente gratuitement.",
  },
  {
    cat: "fiscalite",
    q: "La taxe de séjour est-elle gérée par la conciergerie ?",
    a: "Oui. Nous collectons la taxe de séjour automatiquement via la plateforme (Airbnb la collecte directement, Booking et Vrbo via notre logiciel). Nous effectuons la déclaration trimestrielle auprès de l'agglomération concernée (Saint-Malo Agglomération, Dinan Agglomération…). Aucune action de votre part.",
  },
  {
    cat: "fiscalite",
    q: "Qu'est-ce que la loi LEMEUR de novembre 2024 change pour moi ?",
    a: "La loi n° 2024-1039 du 19 novembre 2024 (dite « loi LEMEUR ») durcit la fiscalité (abattement micro-BIC réduit), impose un DPE de classe au moins F en 2025 (E en 2028, D en 2034), et donne aux maires le pouvoir d'introduire des quotas et de limiter à 90 jours/an la résidence principale. Nous suivons en temps réel ces évolutions par commune et vous alertons à chaque changement local.",
  },

  // === Réglementation locale ===
  {
    cat: "reglementation",
    q: "Faut-il un numéro d'enregistrement pour louer en Airbnb ?",
    a: "Oui, c'est obligatoire dans la quasi-totalité des communes de notre zone. À Saint-Malo et dans les communes de Saint-Malo Agglomération, le numéro à 13 chiffres s'obtient sur taxe.3douest.com/saintmaloagglo.php. À Dinan et Saint-Cast-le-Guildo, via le portail Dinan Agglomération. Nous nous occupons de toute la procédure (24-72h).",
  },
  {
    cat: "reglementation",
    q: "Faut-il une autorisation de changement d'usage ?",
    a: "Pour une résidence secondaire à Saint-Malo, Dinan ou Saint-Cast-le-Guildo, oui. Délais d'instruction : 6 à 12 semaines. Nous montons le dossier complet (formulaire, titre de propriété, règlement de copropriété, DPE, plan, photos) et le déposons à votre place. Voir nos guides dédiés sur le blog (Saint-Malo, Dinan, Saint-Cast).",
  },
  {
    cat: "reglementation",
    q: "Y a-t-il des quotas qui limitent les autorisations à Saint-Malo et Dinan ?",
    a: "Oui. Saint-Malo : 4 secteurs avec plafonds (370 max secteur A intra-muros, 920 secteur B, 360 secteur C, 110 secteur D). Dinan : 5 secteurs (220 Intramuros, 20 Petit Fort, 20 Bourg Léhon, 20 Port, 150 Périphérie). Saint-Cast n'a pas encore de quotas mais cela peut évoluer. Nous vérifions la disponibilité du quota avant tout dépôt de dossier.",
  },
  {
    cat: "reglementation",
    q: "Quelles sanctions si je loue sans déclaration ?",
    a: "Loi LEMEUR : jusqu'à 10 000 € sans numéro d'enregistrement, 20 000 € pour fausse déclaration. Code de la Construction et de l'Habitation : jusqu'à 100 000 € pour location sans autorisation de changement d'usage, plus astreinte de 1 000 €/jour/m². Les contrôles sont actifs depuis 2024 (agents assermentés croisant les annonces avec la base mairie).",
  },

  // === Service & disponibilité ===
  {
    cat: "service",
    q: "Êtes-vous disponibles 24h/24 et 7j/7 ?",
    a: "Oui, totalement. Nous assurons une permanence de jour ET de nuit pour répondre aux messages voyageurs sur les plateformes (Airbnb, Booking, Vrbo) et gérer toute urgence. Notre équipe locale intervient également physiquement en moins de 30 minutes sur la Côte d'Émeraude et en moins de 45 minutes dans le Morbihan.",
  },
  {
    cat: "service",
    q: "Combien de logements gérez-vous ?",
    a: "70 logements pas plus. C'est notre engagement : nous refusons la logique d'usine pour préserver la qualité de service sur chaque bien. Chaque propriétaire est suivi par un City Manager dédié qui connaît son logement, ses voisins et ses spécificités.",
  },
  {
    cat: "service",
    q: "Combien d'équipes avez-vous ?",
    a: "Deux équipes complètement distinctes : une équipe Saint-Malo & Côte d'Émeraude (Ille-et-Vilaine + Côtes-d'Armor) et une équipe Sud Bretagne, Morbihan. Chaque propriétaire est suivi par l'équipe la plus proche de son bien. Un seul numéro central pour vous joindre : 02 55 99 66 25.",
  },
  {
    cat: "service",
    q: "Proposez-vous un service de parrainage ?",
    a: "Oui. Si vous nous recommandez à un voisin ou un ami propriétaire, vous recevez 100 € de remise sur votre 2ᵉ mois de commission ET votre filleul aussi (cumulable jusqu'à 10 parrainages par année civile, soit jusqu'à 1 000 € de remise annuelle). Voir notre page Parrainage pour le détail et le formulaire.",
  },
];
